// src/utils/exportUtils.js

/**
 * Example utility to export data to CSV.
 */
export function exportToCSV(filename, data) {
  const csvContent = data.map(row => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Export content as a placeholder PDF.
 * Replace with a real PDF library like jsPDF later.
 */
export function exportToPDF(filename, elementId) {
  console.log(`Pretend exporting #${elementId} as ${filename}.pdf`);
  // Real implementation could use jsPDF, html2pdf, etc.
}
